export const getCookie = (cookieName) => {
    const cookies = document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${cookieName}=`));
    return cookies ? cookies.split("=")[1] : null;
};

export const deleteCookie = (cookieName) => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}